<script setup lang="ts">
withDefaults(
  defineProps<{
    color?: string;
    markerClass?: string;
    reserveLineAboveSpace?: boolean;
    showLineAbove?: boolean;
    showLineBelow?: boolean;
    visible?: boolean;
  }>(),
  {
    color: undefined,
    markerClass: undefined,
    reserveLineAboveSpace: true,
    showLineAbove: false,
    showLineBelow: false,
    visible: true,
  },
);
</script>

<template>
  <div
    class="flex w-timeline-marker shrink-0 flex-col items-center self-stretch overflow-hidden"
    :class="!visible && 'opacity-0'"
    aria-hidden="true"
  >
    <template v-if="reserveLineAboveSpace || showLineAbove">
      <span class="h-timeline-rail-head w-px shrink-0 bg-surface-divider" :class="!showLineAbove && 'opacity-0'"></span>
      <span class="h-timeline-rail-gap shrink-0"></span>
    </template>
    <span
      class="size-timeline-marker shrink-0 rounded-full"
      :class="markerClass ?? 'bg-current'"
      :style="color ? { backgroundColor: color } : undefined"
    ></span>
    <span v-if="showLineBelow" class="h-timeline-rail-gap shrink-0"></span>
    <span v-if="showLineBelow" class="w-px min-h-0 flex-1 bg-surface-divider"></span>
  </div>
</template>
